import { Alert } from 'reactstrap';
import React from 'react';
function ErrorHandler({ error }) {
    return React.createElement(Alert, { color: "danger" },
        React.createElement("i", { className: "fas fa-exclamation-circle me-1" }),
        error && ((error.response && error.response.data && error.response.data.message) || error.message));
}
export default class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }
    render() {
        if (this.state.hasError) {
            return React.createElement(ErrorHandler, { error: this.state.error });
        }
        return this.props.children;
    }
}
